import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import DataTable from '../../components/DataTable';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';
import ModalShell from '../../components/ModalShell';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

function OdaTipForm({ odaTip, onKaydet, onGeri, kaydediliyor, hata }) {
  const yeni = !odaTip;
  const [form, setForm] = useState(
    odaTip
      ? { ad: odaTip.ad, aciklama: odaTip.aciklama || '', aktifMi: odaTip.aktifMi }
      : { ad: '', aciklama: '', aktifMi: true }
  );
  const [hatalar, setHatalar] = useState({});

  const set = (k, v) => { setForm(p => ({ ...p, [k]: v })); setHatalar(p => ({ ...p, [k]: null })); };

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-violet-400 focus:ring-4 focus:ring-violet-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (!form.ad.trim()) { setHatalar({ ad: 'Oda tipi adı zorunludur.' }); return; }
    onKaydet(form);
  }

  return (
    <ModalShell
      icon={yeni ? '➕' : '✏️'}
      iconColor="from-violet-600 to-indigo-700"
      title={yeni ? 'Yeni Oda Tipi' : `"${odaTip.ad}" Düzenle`}
      subtitle="Oda kategorileri ve teknik tanımlar"
      onClose={onGeri}
      size="md"
      footer={
        <>
          <button onClick={onGeri} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-violet-600 to-indigo-700 hover:from-violet-700 hover:to-indigo-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-violet-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : '💾 TİPİ KAYDET'}
          </button>
        </>
      }
    >
          {(hata || hatalar.genel) && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata || hatalar.genel}</div>}

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">ODA TİPİ ADI *</label>
            <input value={form.ad} onChange={e => {
              const v = e.target.value;
              const formatted = v.toLocaleLowerCase('tr-TR').split(' ').map(s => s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1)).join(' ');
              set('ad', formatted);
            }}
              className={INP(hatalar.ad)} placeholder="Örn: Standart, Deluxe, King Suite" autoFocus onKeyDown={e => e.key === 'Enter' && handleKaydet()} />
            <FormHata mesaj={hatalar.ad} />
          </div>

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">AÇIKLAMA / ÖZELLİKLER</label>
            <textarea rows={3} value={form.aciklama} onChange={e => set('aciklama', e.target.value)}
              className={INP(false) + ' resize-none leading-relaxed'} placeholder="Manzara, yatak sayısı, ek olanaklar vb..." />
          </div>

          <div className="pt-4">
            <label className="flex items-center justify-between bg-gray-50/50 p-4 rounded-2xl border-2 border-gray-100 shadow-inner group select-none cursor-pointer">
              <span className={`text-[10px] font-black uppercase tracking-widest transition-colors duration-300 ${form.aktifMi ? 'text-violet-600' : 'text-gray-400'}`}>TİPİ SATIŞA AÇIK TUT (AKTİF)</span>
              <div className="relative leading-none">
                <input type="checkbox" checked={form.aktifMi} onChange={e => set('aktifMi', e.target.checked)} className="sr-only peer" />
                <div className="w-12 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-violet-600 shadow-sm transform-gpu"></div>
              </div>
            </label>
          </div>

    </ModalShell>
  );
}

export default function OdaTipleri() {
  const [odaTipleri, setOdaTipleri] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [formHata, setFormHata] = useState(null);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [siliniyor, setSiliniyor] = useState(false);
  const [araTip, setAraTip] = useState('');

  const fetchTipler = useCallback(async () => {
    setYukleniyor(true); setHata(null);
    try { const data = await apiRequest('OdaTipi'); setOdaTipleri(data || []); }
    catch { setHata('Veriler yüklenemedi.'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { fetchTipler(); }, [fetchTipler]);

  const handleKaydet = async (form) => {
    setKaydediliyor(true); setFormHata(null);
    try {
      if (secili) {
        await apiRequest(`OdaTipi/${secili.odaTipiId}`, 'PUT', { odaTipiId: secili.odaTipiId, ad: form.ad, aciklama: form.aciklama || '', aktifMi: form.aktifMi, maxKisiSayisi: secili.maxKisiSayisi || 2, kisiBasiAktif: secili.kisiBasiAktif || false, bukletAktifMi: secili.bukletAktifMi || false });
      } else {
        await apiRequest('OdaTipi', 'POST', { ad: form.ad, aciklama: form.aciklama || '', aktifMi: form.aktifMi });
      }
      await fetchTipler(); setView('liste'); setSecili(null);
    } catch { setFormHata('Hata oluştu.'); }
    finally { setKaydediliyor(false); }
  };

  const handleSil = async (id) => {
    setSiliniyor(true);
    try { await apiRequest(`OdaTipi/${id}`, 'DELETE'); setOdaTipleri(p => p.filter(o => o.odaTipiId !== id)); setSilOnay(null); }
    catch (e) { alert(e?.message || 'Silme başarısız. Bu tipe bağlı odalar olabilir.'); }
    finally { setSiliniyor(false); }
  };

  const filtreli = odaTipleri.filter(o => !araTip || o.ad?.toLocaleLowerCase('tr-TR').includes(araTip.toLocaleLowerCase('tr-TR')));
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn leading-none" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="🛌"
        iconColor="from-violet-600 to-indigo-700"
        iconShadow="shadow-violet-200"
        title="Oda Tipleri"
        subtitle="Oda kategorileri ve kategori bazlı tanımlar"
      >
        <button onClick={() => { setSecili(null); setFormHata(null); setView('ekle'); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-violet-100 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden leading-none">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90 leading-none">＋</span>
          <span className="relative">YENİ ODA TİPİ EKLE</span>
        </button>
      </PageHeader>

      {/* Özet Kartlar */}
      {odaTipleri.length > 0 && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 leading-none">
          {odaTipleri.slice(0, 4).map((o, i) => {
            const renkler = [
              'from-violet-500 to-indigo-600 shadow-violet-100',
              'from-emerald-500 to-teal-600 shadow-emerald-100',
              'from-blue-500 to-blue-700 shadow-blue-100',
              'from-amber-400 to-orange-500 shadow-amber-100',
            ];
            return (
              <div key={o.odaTipiId} className={`relative overflow-hidden rounded-[2rem] bg-gradient-to-br ${renkler[i % 4]} p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300 group cursor-default h-32 flex flex-col justify-between text-left`}>
                <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500 transform-gpu">🛌</div>
                <div className="relative">
                  <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none text-left">Oda Tipi</p>
                  <p className="font-black text-lg tracking-tight truncate leading-tight text-left">{o.ad}</p>
                </div>
                <div className="relative">
                  <span className={`text-[9px] font-black px-3 py-1.5 rounded-lg border leading-none inline-block ${o.aktifMi ? 'bg-white/20 text-white border-white/30' : 'bg-black/10 text-white/40 border-black/5'}`}>
                    {o.aktifMi ? 'AKTİF' : 'PASİF'}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Tablo */}
      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full text-left">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black leading-none">🔍</span>
            <input value={araTip} onChange={e => setAraTip(e.target.value)} placeholder="Tipi ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-violet-400 focus:outline-none bg-white transition-all shadow-sm font-bold leading-none" />
          </div>
          <div className="flex items-center gap-3 ml-auto leading-none">
            <button onClick={fetchTipler} className="h-12 px-8 flex items-center gap-3 text-[10px] font-black uppercase tracking-widest text-gray-500 bg-white border-2 border-gray-100 rounded-2xl hover:bg-gray-50 hover:border-violet-100 transition-all shadow-sm active:scale-95 leading-none">
              <span className={`w-4 h-4 ${yukleniyor ? 'animate-spin' : ''}`}>⟳</span>
              Yenile
            </button>
            <p className="hidden sm:block text-[10px] font-black text-gray-400 uppercase tracking-widest ml-4 whitespace-nowrap">TANIMLI: <b className="text-violet-600 text-xs">{odaTipleri.length}</b></p>
          </div>
        </div>

        {yukleniyor ? (
          <LoadingSpinner fullPage text="Veriler Çekiliyor..." />
        ) : (
          <>
            <div className="md:hidden divide-y divide-gray-100 px-2 leading-none">
              {filtreli.length === 0 ? (
                <EmptyState icon="🛌" text="Eşleşen tip bulunamadı" />
              ) : filtreli.map(o => (
                <div key={o.odaTipiId} className={`p-6 flex flex-col gap-5 hover:bg-violet-50/20 transition-all rounded-[2rem] group transform-gpu ${!o.aktifMi ? 'grayscale' : ''}`}>
                  <div className="flex items-center justify-between gap-4 leading-none text-left">
                    <div className="flex items-center gap-5 min-w-0">
                      <div className="w-14 h-14 bg-gradient-to-br from-violet-50 to-indigo-50 border border-violet-100 rounded-2xl flex items-center justify-center text-2xl shadow-xl shadow-violet-100/50 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 transform-gpu leading-none text-violet-600 font-black">🛌</div>
                      <div className="min-w-0">
                        <p className="font-black text-gray-700 text-lg tracking-tight truncate leading-none mb-2 uppercase">{o.ad}</p>
                        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest truncate leading-none max-w-[200px] opacity-70">{o.aciklama || 'Açıklama girilmemiş'}</p>
                      </div>
                    </div>
                    <span className={`flex-shrink-0 text-[10px] font-black px-3 py-1.5 rounded-lg border tracking-widest transition-colors leading-none ${o.aktifMi ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-gray-100 text-gray-400 border-gray-200'}`}>
                      {o.aktifMi ? '✓ AKTİF' : '✗ PASİF'}
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <EditButton size="lg" onClick={() => { setSecili(o); setFormHata(null); setView('duzenle'); }} />
                    <DeleteButton size="lg" onClick={() => setSilOnay(o.odaTipiId)} />
                  </div>
                </div>
              ))}
            </div>

            <div className="hidden md:block overflow-x-auto leading-none">
              <DataTable
                anahtarAlan="odaTipiId"
                satirlar={filtreli}
                bosIkon="🛌"
                bosMetin="Tanımlı oda tipi bulunamadı"
                satirSinifi={o => !o.aktifMi ? 'grayscale-[0.8] opacity-60 bg-gray-50/50' : ''}
                kolonlar={[
                  {
                    anahtar: 'sira', baslik: '#', genislik: 'w-20',
                    ciz: (o, i) => <span className="font-black text-gray-300 text-xs">{i + 1}</span>,
                  },
                  {
                    anahtar: 'ad', baslik: 'Oda Tipi Bilgisi',
                    ciz: o => (
                      <div className="flex items-center gap-5 min-w-0">
                        <div className="w-12 h-12 bg-white rounded-2xl shadow-lg shadow-violet-50 border border-gray-100 flex-shrink-0 flex items-center justify-center text-xl font-emoji">🛌</div>
                        <span className="font-black text-gray-700 text-lg uppercase tracking-tight truncate">{o.ad}</span>
                      </div>
                    ),
                  },
                  {
                    anahtar: 'aciklama', baslik: 'Açıklama',
                    ciz: o => (
                      <span className="text-[11px] font-bold text-gray-400 line-clamp-2 uppercase tracking-tight">{o.aciklama || '—'}</span>
                    ),
                  },
                  {
                    anahtar: 'aktifMi', baslik: 'Durum', hizala: 'orta', genislik: 'w-32',
                    ciz: o => (
                      <div className={'inline-flex items-center px-4 py-2 rounded-2xl border ' +
                        (o.aktifMi ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-gray-100 text-gray-400 border-gray-200')}>
                        <span className="text-[10px] font-black uppercase tracking-widest">{o.aktifMi ? '✓ AKTİF' : '✗ PASİF'}</span>
                      </div>
                    ),
                  },
                  {
                    anahtar: 'islem', baslik: 'İşlemler', hizala: 'sag',
                    ciz: o => (
                      <ActionButtons
                        onEdit={() => { setSecili(o); setFormHata(null); setView('duzenle'); }}
                        onDelete={() => setSilOnay(o.odaTipiId)} />
                    ),
                  },
                ]}
              />
            </div>
          </>
        )}
      </div>

      <UsageInfo
        color="violet"
        description="Oda Tipleri (Oda Kategorileri), tesisinizdeki odaların niteliklerine göre (Örn: Standart, Suite) sınıflandırılmasını sağlar."
        scenarios={[
          { title: "Kapasite Yönetimi", content: "Yeni bir oda eklerken veya fiyatlandırma kurgularken doğrudan bu tiplere ihtiyaç duyarsınız." },
          { title: "Satış Stratejisi", content: "Online kanallarda veya acentelerde odalar bu tiplere göre pazarlanır. Fiyatlandırma motoru tip bazlı çalıştığı için kategorizasyon kritiktir." }
        ]}
      />

      {isOpen && createPortal(
        <OdaTipForm
          odaTip={secili}
          onKaydet={handleKaydet}
          onGeri={() => { setView('liste'); setSecili(null); setFormHata(null); }}
          kaydediliyor={kaydediliyor}
          hata={formHata}
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Oda Tipini Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-10 leading-relaxed uppercase tracking-tight text-center">Bu kategori kalıcı olarak silinecek. Atanmış odalar etkilenebilir. Emin misiniz?</p>
            <div className="flex gap-4 leading-none">
              <button onClick={() => setSilOnay(null)}
                className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} disabled={siliniyor}
                className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95 leading-none transform-gpu">
                {siliniyor ? '⌛' : 'EVET, SİL'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}